<template>
    <div class="tableWrapper">
        <FusionTable :config="tableData"
                     v-on:scrollDown="tableScroll"
        />
    </div>
</template>

<script>
import { FusionTable } from '@ironsrc/fusion-ui/native/vue/fusion-vue';
import { renderNativeElement } from 'services/libWrappers/fusionHelper';
import consts from './consts';

export default {
    name: 'Table',
    components: {
        FusionTable
    },
    props: {
        columns: {
            type: Array,
            required: true
        },
        rows: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rowsCursor: 0,
            rowsBatchSize: 30,
            enableScroll: true
        };
    },
    computed: {
        tableData() {
            return {
                columns: this.tableColumns,
                rows: this.rowsDataBatch,
                loading: this.loading,
                options: {
                    sortingType: 'local',
                    stickyHeader: true,
                    pagination: {
                        enable: this.enableScroll
                    }
                }
            };
        },
        tableColumns() {
            return this.columns.map(({ isComponent, ...column }) => {
                if (!isComponent) {
                    return column;
                }

                return {
                    ...column,
                    type: consts.TABLE_CELL_TYPES.COMPONENT,
                    renderNativeElement
                };
            });
        },
        rowsDataBatch() {
            return this.enableScroll ? this.rows.slice(0, this.currentRowsNumber) : this.rows;
        },
        currentRowsNumber() {
            return this.rowsBatchSize + (this.rowsBatchSize * this.rowsCursor);
        }
    },
    methods: {
        tableScroll() {
            if (this.currentRowsNumber < this.rows.length) {
                this.rowsCursor += 1;
            }
        }
    }
};
</script>

<style scoped>
    .tableWrapper {
        position: relative;
    }
</style>
